import {Card, CardContent, Typography} from '@mui/material'
import React from 'react'
import {useNavigate} from 'react-router-dom'
import {useAuth} from '../../auth/auth'
import {RouteSecurity} from '../RouteSecurity'

type CommonProps = {
    title: string,
    text?: string,
    style?: React.CSSProperties
    children?: React.ReactNode
}

type ExclusiveProps = | {
    route?: never,
    clickHandler: () => void,
} | {
    route: string,
    clickHandler?: never,
}

type DashboardCardProps = CommonProps & ExclusiveProps

export function  DashboardLinkCard({route, title, text, clickHandler, children, style = {}}: DashboardCardProps) {
    const {getPermissions} = useAuth()
    const navigate = useNavigate()
    let routeSecurity = new RouteSecurity(getPermissions())

    return (
        <>
            {route? <>
                {routeSecurity.isAuthorized(route) && (
                    <Card onClick={() => navigate(route)} sx={{
                        width: '100%',
                        height: 100,
                        border: 3,
                        borderRadius: 2,
                        borderColor: 'transparent',
                        cursor: 'pointer',
                        ...style,
                        '&:hover': {
                            borderColor: 'primary.main',
                        }
                    }}>
                        <CardContent>
                            <Typography variant="h6" component="div">{title}</Typography>
                            <Typography color="text.secondary">
                                {text}
                            </Typography>
                            {children}
                        </CardContent>
                    </Card>
                )}
            </>:
            <>
                { clickHandler && (<Card onClick={() => clickHandler()} sx={{
                    width: '100%',
                    height: 100,
                    border: 3,
                    borderRadius: 2,
                    borderColor: 'transparent',
                    cursor: 'pointer',
                    ...style,
                    '&:hover': {
                        borderColor: 'primary.main',
                    }
                }}>
                    <CardContent>
                        <Typography variant="h6" component="div">{title}</Typography>
                        <Typography color="text.secondary">
                            {text}
                        </Typography>
                        {children}
                    </CardContent>
                </Card>)
                }
            </>
            }
        </>
    )
}
